/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import React from 'react'
import { API_IMG_AVATR, ApiResponse, KPISummaryService, KpiSummaryDto, KpiSummaryFilterDto, SeasonDto, TableDto, UserHealthDto, UserHealthFilterDto, UserHealthService, UserProfileDto, UserProfileService } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import { KTSVG, } from '_metronic/helpers'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'setup'
import moment from 'moment'

import { ImageCrop, PaginationStd } from 'app/components'
import { UserModel } from 'app/modules/auth/models/UserModel'
import clsx from 'clsx'



const ProfilePage: FC = () => {
    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const userLogin = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

    const defaultEmpty = {
        result: [],
        totalRows: 0,
        message: '',
        statusCode: 0,
        errorCode: 0,
        isSuccess: false

    }
    const navigate = useNavigate()
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<UserProfileDto | undefined>()
    const [kpiData, setKPIData] = useState<ApiResponse<TableDto>>()
    const [healthData, setHealthData] = useState<ApiResponse<UserHealthDto[]>>(defaultEmpty)
    const [kpiFilter, setKpiFilter] = useState<KpiSummaryFilterDto>({
        userProfileId: userLogin.id,
        page: 0,
        length: 10
    })
    const [healthFilter, setHealthFilter] = useState<UserHealthFilterDto>({
        userProfileId: userLogin.id,
        page: 0,
        length: 10
    })


    useEffect(() => {
        const load = () => {
            if (lastSeason) {
                UserProfileService.GetById(userLogin.id).then((result) => {
                    const row = result.data.result
                    setData(row)
                })
            }
        }
        load()
    }, [lastSeason, reload])


    useEffect(() => {
        const loadKpi = () => {
            UserProfileService.GetBroad().then((result) => {
                setKPIData(result.data)
            })
        }
        loadKpi();
    }, [lastSeason, kpiFilter])

    useEffect(() => {
        const loadHealth = () => {
            UserHealthService.GetLast(healthFilter).then((result) => {
                setHealthData(result.data)
            })

        }
        loadHealth();
    }, [lastSeason, healthFilter])


    const getTotalWorkingDay = () => {
        if (data) {
            var df = new Date(data.startWorkingDate)
            var dt = new Date()
            var allYears = dt.getFullYear() - df.getFullYear();
            var totalMonth = dt.getMonth() - df.getMonth();
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds           
            const totalDay = Math.floor(Math.abs((dt.valueOf() - df.valueOf()) / oneDay));
            return `${allYears} ปี ${totalMonth} เดือน ${totalDay} วัน`

        }
        return '0 ปี 0 เดือน 0 วัน'
    }
    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>
                <div className='card-header cursor-pointer'>

                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>

                </div>
                {/* begin::Body */}
                <div className='card-body py-3 '>
                    <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                        <div className='me-7 mb-4'>
                            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                                {/* <ImageAvatar fielName={userLogin?.avatar} /> */}
                                <ImageCrop
                                    hasData={userLogin?.avatar ? true : false}
                                    src={`${API_IMG_AVATR}/${userLogin?.avatar}`}
                                    alt='imgCalender'
                                />
                                <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div>
                            </div>
                        </div>

                        <div className='flex-grow-1'>
                            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                                <div className='d-flex flex-column'>
                                    <div className='d-flex align-items-center mb-2'>
                                        <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                                            {`${data?.firstName ?? ''} ${data?.lastName ?? ''}`}
                                        </a>
                                        <a href='#'>
                                            <KTSVG
                                                path='/media/icons/duotune/general/gen026.svg'
                                                className='svg-icon-1 svg-icon-primary'
                                            />
                                        </a>
                                    </div>

                                    <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                                        <a
                                            href='#'
                                            className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                                        >
                                            <label className='fw-bolder'>รหัสพนักงาน :</label>
                                            {data?.employeeId ?? '-'}
                                        </a>
                                        <a
                                            href='#'
                                            className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                                        >
                                            <label className='fw-bolder'>สังกัด :</label>
                                            {data?.affiliateCode ?? '-'}
                                        </a>

                                        <a
                                            href='#'
                                            className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                                        >
                                            <label className='fw-bolder'>ประเภทพนักงาน :</label>
                                            {data?.workingTypeCode ?? '-'}
                                        </a>

                                    </div>
                                </div>


                            </div>

                            <div className='d-flex flex-wrap flex-stack'>

                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                                    <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                                        <span className='fw-bold fs-6 text-gray-400'>Level 1</span>
                                        <span className='fw-bolder fs-6'>50%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                        <div
                                            className='bg-success rounded h-5px'
                                            role='progressbar'
                                            style={{ width: '50%' }}
                                        ></div>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex flex-wrap'>

                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                                    <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                                        <span className='fw-bold fs-6 text-gray-400'> อายุงาน</span>
                                        <span className='fw-bold fs-6 text-gray-400'> {getTotalWorkingDay()}</span>
                                    </div>

                                </div>
                            </div>
                            <div className='d-flex flex-wrap'>
                                <button className='btn btn-sm btn-primary' onClick={() => navigate(`/profile-detail/${userLogin.id}`)}>Edit</button>
                            </div>
                        </div>


                    </div>


                </div>

                {/* begin::Body */}
            </div>
            <div className='card mb-5 mb-xl-8 '>
                <div className='card-body py-3' >

                    <div className='btn btn-primary' onClick={() => navigate(`/profile-health/new`)}> ส่งผลตรวจสุขภาพ</div>
                    <div className='m-20' style={{ minHeight: '200px' }}>
                        <table className='table' >
                            <tbody>
                                {kpiData && kpiData.result.rows.map((item, index) => {
                                    return <tr key={index}>
                                        <td>{`${item[0]}`}</td>
                                        <td>{item[1]}</td>
                                        <td>{`${item[2]}`} </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>


                    {/* <div>
                        <PaginationStd
                            pageSetting={{
                                currentPage: kpiFilter.page,
                                totalRow: kpiData.totalRows,
                                pageSize: 10,
                            }}
                            onPageChange={(e: any, page: number) => setKpiFilter({
                                ...kpiFilter,
                                page
                            })}
                            isLoading={false}
                        />
                    </div> */}
                </div>

            </div >
            <div className='card mb-5 mb-xl-8 '>
                <div className='card-body py-3'>

                    <div className='btn btn-primary' onClick={() => navigate(`/profile-health/new`)}> ส่งผลตรวจสุขภาพ</div>
                    <div className='m-20' style={{ minHeight: '200px' }}>
                        <table className='table'>
                            <tbody>
                                {healthData.result.map((item, index) => {
                                    return <tr key={index}>
                                        <td>{moment(item.recordDate).format("YYYY")}</td>
                                        <td className={clsx({ 'text-danger': item.status !== '' })}>{item.status}</td>
                                        <td><button
                                            type='button'
                                            onClick={(e) =>
                                                navigate(`/profile-health/${item.id}`)
                                            }
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                            <KTSVG
                                                path='/media/icons/duotune/art/art005.svg'
                                                className='svg-icon-3'
                                            />
                                        </button></td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                        <div>
                            <PaginationStd
                                pageSetting={{
                                    currentPage: healthFilter.page,
                                    totalRow: healthData.totalRows,
                                    pageSize: 10,
                                }}
                                onPageChange={(e: any, page: number) => setHealthFilter({
                                    ...healthFilter,
                                    page
                                })}
                                isLoading={false}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
export { ProfilePage }
